import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  MessageDivider,
  MessageStatusContainer,
  MessageStatusText,
  StatusBox
} from './styled';
import { MessageStatusProps } from './types';
import { getStatusType } from '../../../../utils/helpers/getStatusType';

export const MessageStatus: React.FC<MessageStatusProps> = ({
  isPending,
  isExpired,
  isLimited,
  isRejected,
  isExpiredManually,
  isLeased,
  rejectReason,
  expiresAt
}) => {
  const { t } = useTranslation();

  const defaultGetStatusProps = {
    isExpired,
    isExpiredManually,
    isLeased,
    isPending,
    isLimited,
    isRejected
  };

  const statusType = getStatusType(defaultGetStatusProps);
  const messageStatus = getStatusType({
    ...defaultGetStatusProps,
    translations: true
  });

  return (
    <MessageStatusContainer data-cy="message-status">
      <MessageDivider $status={statusType} />

      <StatusBox data-cy={`message-status__${statusType}`} $status={statusType}>
        <MessageStatusText tag="body_1">
          {t(`pages.current_item.status_message.${messageStatus}`)}
        </MessageStatusText>

        {isLimited && (
          <MessageStatusText tag="body_1" $asBlock>
            {t('pages.current_item.status_message.limited_additional')}
          </MessageStatusText>
        )}

        {isRejected && (
          <MessageStatusText tag="body_1" $asBlock>
            {rejectReason}
          </MessageStatusText>
        )}

        {(isExpiredManually || isExpired) && expiresAt && (
          <MessageStatusText tag="body_1">: {expiresAt}</MessageStatusText>
        )}
      </StatusBox>
    </MessageStatusContainer>
  );
};
